import { Box, Divider, Grid, List, ListItem, ListItemText } from "@material-ui/core";
import { sanitizeTestId } from "@roc/feature-utils";
import { TestDataAttribute } from "@roc/ui";
import { formatCurrency } from "@roc/ui/utils";
import { useRocInternalPortalStore } from "apps/roc-internal-portal/src/app/hooks";
import { CustomCard } from "libs/feature-loan-details/src/loanDetails/components/customCard";
import { observer } from "mobx-react";


export const WireDetails = observer(() => {

  const { sendWireInternalStore } = useRocInternalPortalStore();
  let style = { boxShadow: 'none !important' };

  return (
    <CustomCard title="Wire Summary" cardContentProps={{ style: { padding: 0 } }} paperStyle={style}>
      <Grid container>
        <Grid item xs={12}>
          <Box>
            <List style={{ padding: '0px' }}>
              {listItem('Total Draw Amount', formatCurrency(sendWireInternalStore.summaryInformation?.totalDrawAmount), false, null, 'green')}
              {divider}
              {listItem('Wire Fees', `(${formatCurrency(sendWireInternalStore.summaryInformation?.wireFees)})`)}
              {divider}
              {listItem('Total Inspection Fees', `(${formatCurrency(sendWireInternalStore.summaryInformation?.inspectionFees)})`)}
              {divider}
              {listItem('Total Other Receivables Fees', `(${formatCurrency(sendWireInternalStore.summaryInformation?.otherReceivablesFees)})`)}
              {divider}
              {listItem('Total DQ Amount', `(${formatCurrency(sendWireInternalStore.summaryInformation?.totalDqAmount)})`)}
              {divider}
              {listItem('Net Wire Amount', formatCurrency(sendWireInternalStore.summaryInformation?.netWireAmount), true, null, 'green')}
            </List>
          </Box>
        </Grid>
      </Grid>
    </CustomCard>
  )
})

const listItem = (label, value, bold = false, customTestId = null, color = 'red') => {
  const testId = sanitizeTestId(customTestId || label);

  return (
    <ListItem>
      <ListItemText>
        <Box display="flex">
          <Box flexGrow={1} mr={1}>
            {bold ? <strong>{label}</strong> : label}
          </Box>
          <TestDataAttribute id={testId}>
            <Box textAlign="right" style={{ color }}>{bold ? <strong>{value}</strong> : value}</Box>
          </TestDataAttribute>
        </Box>
      </ListItemText>
    </ListItem>
  );
};

const divider = <Divider variant="middle" component="li" />;